const { getOffsetTop } = window.BAO.Utils

class TextReveal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    window.setTimeout(() => {
      this.setupWords()

      this.updateEl()
    }, 500)

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.revealText()
  }

  setupWords () {
    const wordsArray = this.els.message.element.innerText.split(' ')

    let originalContent = ''
    let overlayContent = ''

    wordsArray.forEach((word) => {
      originalContent += `<span>${word}</span> `
      overlayContent += `<span class="${this.dataset.class}" data-text-reveal-el="word">${word}</span> `
    })

    this.els.message.element.innerHTML = originalContent
    this.els.overlay.element.innerHTML = overlayContent
  }

  revealText () {
    const endOffset = window.BAO.MediaBreakpoints.isSm ? 100 : 50
    const elementStartPoint =
      getOffsetTop(this.els.message.element) - window.innerHeight / 2.5
    const elementEndPoint =
      elementStartPoint + this.els.message.element.offsetHeight + endOffset

    if (!this.els.word?.selector) return

    const wordEls = this.querySelectorAll(this.els.word.selector)

    if (this.lastKnownY <= elementStartPoint) {
      wordEls.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      })

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      wordEls.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      })

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    wordEls.forEach((wordEl, index) => {
      const minimumPercent = index / wordEls.length
      const maximumPercent = (index + 1) / wordEls.length
      const isWithinRange =
        scrollYAsAPercentageOfJourney >= minimumPercent &&
        scrollYAsAPercentageOfJourney < maximumPercent

      if (isWithinRange) {
        const wordScrolledAmount =
          scrollYAsAPercentageOfJourney - minimumPercent
        const wordMaxAmount = maximumPercent - minimumPercent

        const wordProgress = wordScrolledAmount / wordMaxAmount

        const wordProgressAmount = Math.round(wordProgress * 100 * 10) / 10

        wordEl.style.setProperty('--Reveal_Amount', `${wordProgressAmount}%`)
      } else if (scrollYAsAPercentageOfJourney > maximumPercent) {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      } else {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      }
    })
  }
}

if (!customElements.get('text-reveal')) {
  customElements.define('text-reveal', TextReveal)
}
